// extracted by mini-css-extract-plugin
module.exports = {"lg":"styles-module__lg___2_eyV"};